import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { trackMetaPageView } from '../services/metaConversionsService';

/**
 * Owns Meta PageView for the whole SPA — the initial load and every subsequent
 * route change — so each one carries an eventId and can be deduplicated against
 * the server-side copy.
 *
 * Gated on REACT_APP_META_CAPI_ENABLED because the pixel's own automatic
 * PageView has to be switched off in Events Manager first (docs/META-CAPI.md).
 * Until that lands this hook stays inert, otherwise every view is counted
 * twice.
 */
const useMetaPageView = () => {
  const location = useLocation();
  const lastTracked = useRef(null);

  useEffect(() => {
    if (process.env.REACT_APP_META_CAPI_ENABLED !== 'true') return;

    // React 18 StrictMode double-invokes effects in development, and a query
    // string change alone is not a new view.
    const key = location.pathname;
    if (lastTracked.current === key) return;
    lastTracked.current = key;

    trackMetaPageView();
  }, [location.pathname]);
};

export default useMetaPageView;
